import React from "react";
import { AppleStoreLink, AndroidStoreLink, Text } from "@origin-digital/style-guide";
import styled from "styled-components";
import { CTALink } from "./CTALink";
import { sendInteractionEvent } from "../NextBestAction.utils";
import { CTAAction } from "./CTAAction";
var StyledAppleStoreLink = styled(AppleStoreLink).withConfig({
  displayName: "Footer__StyledAppleStoreLink",
  componentId: "sc-1ezmjnt-0"
})(["margin-right:16px;"]);
var Terms = styled.div.withConfig({
  displayName: "Footer__Terms",
  componentId: "sc-1ezmjnt-1"
})(["color:#666;a{color:#666;}"]);
var Stack = styled.div.withConfig({
  displayName: "Footer__Stack",
  componentId: "sc-1ezmjnt-2"
})(["margin-top:24px;button{white-space:normal;}& > *:not(:last-child){margin-bottom:16px;}"]);
var AppLinks = styled.div.withConfig({
  displayName: "Footer__AppLinks",
  componentId: "sc-1ezmjnt-3"
})(["display:flex;flex-direction:row;flex-wrap:wrap;margin-top:-16px;a{display:inline-block;margin-top:16px;}"]);
export var Footer = function Footer(_ref) {
  var _ref$content = _ref.content,
      experienceId = _ref$content.experienceId,
      buttonLink = _ref$content.buttonLink,
      newTab = _ref$content.newTab,
      _ref$content$buttonKi = _ref$content.buttonKind,
      buttonKind = _ref$content$buttonKi === void 0 ? "secondary" : _ref$content$buttonKi,
      buttonText = _ref$content.buttonText,
      hideCTA = _ref$content.hideCTA,
      enableAppStore = _ref$content.enableAppStore,
      appStoreLink = _ref$content.appStoreLink,
      enablePlayStore = _ref$content.enablePlayStore,
      playStoreLink = _ref$content.playStoreLink,
      terms = _ref$content.terms,
      context = _ref.context,
      cardName = _ref.cardName,
      ctaAction = _ref.ctaAction,
      caids = _ref.caids,
      onSuccess = _ref.onSuccess;
  var showAppLinks = enableAppStore || enablePlayStore;
  return React.createElement(Stack, null, showAppLinks && React.createElement(AppLinks, null, enableAppStore && React.createElement(StyledAppleStoreLink, {
    href: appStoreLink
  }), enablePlayStore && React.createElement(AndroidStoreLink, {
    href: playStoreLink
  })), hideCTA ? null : React.createElement("div", {
    "data-id": "next-best-action-button-analytics",
    onClickCapture: sendInteractionEvent(buttonText, experienceId, context, cardName)
  }, ctaAction ? React.createElement(CTAAction, {
    ctaAction: ctaAction,
    onSuccess: onSuccess,
    label: buttonText,
    kind: buttonKind
  }) : React.createElement(CTALink, {
    buttonLink: buttonLink,
    kind: buttonKind,
    newTab: newTab,
    caids: caids
  }, buttonText)), terms && React.createElement(Text, {
    size: "xs",
    overflow: "normal"
  }, React.createElement(Terms, {
    dangerouslySetInnerHTML: {
      __html: terms
    }
  })));
};